import { createMuiTheme } from "@material-ui/core";
import "../assets/styles/fonts.css";
import colors from "./colors";
const typography = {
    h1: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "-0.47px",
    },
    h2: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 700,
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "-0.33px",
    },
    h3: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "-0.18px",
    },
    h4: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    h5: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.01px",
    },
    caption: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.02px",
    },
    p1: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "-0.18px",
    },
    p1Medium: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "-0.18px",
    },
    p1Bold: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "-0.18px",
    },
    p2: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "-0.09px",
    },
    p2Medium: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "-0.09px",
    },
    p2Bold: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "-0.09px",
    },
    p3: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    listItemText: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    listItemNavText: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    inputText: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    buttonTextPrimary: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    buttonTextSecondary: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    linkPrimary: { fontFamily: "Inter, Roboto, Arial" },
    linkSecondary: { fontFamily: "Inter, Roboto, Arial" },
    buttonTextBreadcrumbs: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
    },
    lawExplanations: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 400,
        letterSpacing: "0.05px",
        fontSize: "11px",
        lineHeight: "12px",
    },
    tooltip: {
        fontFamily: "Inter, Roboto, Arial",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.02px",
    },
    segmentControlTextPrimary: {
        fontFamily: "Inter, Roboto, Arial",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "-0.09000000357627869px",
    },
};
export const palette = {
    primary: { main: "#136DEC" },
    secondary: {
        main: "#52637A",
    },
    cell: {
        default: colors.cellDefault,
        hover: colors.cellHover,
        pressed: colors.cellPressed,
        selected: colors.cellSelected,
        tableHover: colors.cellTableHover,
        tableSelected: colors.cellTableSelected,
    },
    text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
        tertiary: colors.textTertiary,
        placeholder: colors.textPlaceholder,
        breadcrumbs: colors.textBreadcrumbs,
        disable: colors.textDisable,
        error: colors.statusTextError,
        success: colors.statusTextSuccess,
        hint: colors.textDisable,
        onColor: "#fff",
        borderColor: "#66A6FF",
        hover: "#EBEDF0",
    },
    icon: {
        primary: colors.iconPrimary,
        secondary: colors.iconSecondary,
        tertiary: colors.iconTertiary,
        disabled: colors.iconDisabled,
        success: colors.iconSuccess,
        info: colors.messageIconInfo,
        confirm: colors.messageIconConfirm,
        error: colors.messageIconError,
        warning: colors.messageIconWarning,
        onColor: "#fff",
    },
    loader: {
        light: "#fff",
        dark: colors.iconSecondary,
        tertiary: colors.iconTertiary,
    },
    textField: {
        hover: colors.textFieldHover,
        disabled: colors.textFieldDisabled,
        inactive: colors.textFieldInactive,
        focus: colors.textFieldFocus,
    },
    toggle: {
        hover: colors.toggleHover,
        pressed: colors.togglePressed,
        disabled: colors.toggleDisabled,
        inactive: colors.toggleInactive,
        focus: colors.toggleHover,
        checkedHover: colors.toggleCheckedHover,
        checkedEnable: colors.toggleCheckedEnable,
        checkedPressed: colors.toggleCheckedPressed,
    },
    status: {
        newBg: colors.statusBgNew,
        neutralBg: colors.statusBgNeutral,
        successBg: colors.statusBgSuccess,
        errorBg: colors.statusBgError,
        disabledBg: colors.statusBgNeutral,
        infoBg: colors.statusBgInfo,
        warningBg: colors.statusWarning,
        newText: colors.statusTextNew,
        neutralText: colors.statusTextNeutral,
        successText: colors.statusTextSuccess,
        errorText: colors.statusTextError,
        disabledText: colors.textDisable,
        infoText: colors.statusTextInfo,
        warningText: colors.statusTextWarning,
    },
    border: {
        textField: colors.borderTextField,
        textFieldError: colors.borderTextFieldError,
        focus: colors.borderFocus,
        toggle: colors.borderToggle,
        menuContainer: colors.borderMenuContainer,
    },
    link: {
        primary: colors.linkPrimary,
        disabled: colors.linkDisabled,
        hover: colors.linkHover,
        secondary: colors.linkSecondary,
    },
    calendar: {
        today: colors.calToday,
        inPeriod: colors.calInPeriod,
        periodHover: colors.calPeriodHover,
        periodSelected: colors.calPeriodSelected,
        periodPressed: colors.calPeriodPressed,
    },
    button: {
        secondaryEnabled: colors.buttonSecondaryEnabled,
        secondaryHover: colors.buttonSecondaryHover,
        secondaryPressed: colors.buttonSecondaryPressed,
        secondarySelected: colors.buttonSecondarySelected,
        primaryEnabled: colors.buttonPrimaryEnabled,
        primaryHover: colors.buttonPrimaryHover,
        primaryPressed: colors.buttonPrimaryPressed,
        tertiaryHover: colors.buttonTertiaryHover,
        tertiaryPressed: colors.buttonTertiaryPressed,
        tertiarySelected: colors.buttonTertiarySelected,
        disabled: colors.buttonDisabled,
    },
    tabs: {
        selected: "#136DEC",
        enabled: "#52637A",
    },
    segmentedControls: {
        selected: colors.segmentSelected,
        backgroundColor: colors.bgSegmentedControls,
    },
    dividerUnsupported: {
        regular: colors.dividerRegular,
        bold: colors.dividerBold,
    },
    background: {
        paper: colors.bgPrimary,
        default: colors.bgPrimary,
        primary: colors.bgPrimary,
        secondary: colors.bgSecondary,
        overlay: colors.bgSecondary,
    },
};
const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
export const theme = createMuiTheme({
    spacing: 4,
    palette,
    typography,
    zIndex: {
        drawer: 1300,
        appBar: 1500,
        modal: 1400,
        snackbar: 1600,
        tooltip: 1700,
    },
    overrides: {
        MuiSvgIcon: {
            colorSecondary: {
                color: "#52637a",
            },
            fontSizeSmall: {
                width: "20px",
                height: "20px",
            },
        },
        MuiIcon: {
            colorSecondary: {
                color: "#52637a",
            },
        },
        MuiIconButton: {
            edgeStart: {
                padding: "0px",
            },
            sizeSmall: {
                padding: "4px",
            },
        },
        MuiCssBaseline: (() => {
            const styles = {
                "@global": {
                    a: {
                        textDecoration: "none",
                        color: "inherit",
                    },
                    "body, html, #root": {
                        margin: 0,
                        height: "100%",
                    },
                    body: Object.assign({ backgroundColor: palette.background.default, overflow: "hidden" }, typography.p1),
                },
            };
            if (!isMac)
                return Object.assign(Object.assign({}, styles), { "*::-webkit-scrollbar-track": {
                        boxShadow: "inset 0.5px 0px 0px rgba(0, 0, 0, 0.07), inset 1px 0px 0px rgba(0, 0, 0, 0.02), inset -1px 0px 0px rgba(0, 0, 0, 0.02), inset -0.5px 0px 0px rgba(0, 0, 0, 0.07)",
                    }, "*::-webkit-scrollbar": {
                        width: "4px",
                    }, "*::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0,0,0,.51)",
                        borderRadius: "4px",
                    } });
            return styles;
        })(),
    },
});
export default typography;
//# sourceMappingURL=theme.js.map